import {
  Info,
  KeyRound,
  MessageSquare,
  Pencil,
  Play,
  Plus,
  Share2,
  Trash2,
  type LucideIcon,
} from "lucide-react";
import type { AuditActionIntent } from "../../utils";

export const INTENT_STYLES: Record<AuditActionIntent, { Icon: LucideIcon; className: string }> = {
  create: { Icon: Plus, className: "bg-green-50 text-green-700 ring-green-200" },
  update: { Icon: Pencil, className: "bg-blue-50 text-blue-700 ring-blue-200" },
  delete: { Icon: Trash2, className: "bg-red-50 text-red-700 ring-red-200" },
  chat: { Icon: MessageSquare, className: "bg-blue-50 text-blue-700 ring-blue-200" },
  trigger: { Icon: Play, className: "bg-gray-100 text-gray-600 ring-gray-200" },
  share: { Icon: Share2, className: "bg-blue-50 text-blue-700 ring-blue-200" },
  security: { Icon: KeyRound, className: "bg-amber-50 text-amber-700 ring-amber-200" },
  neutral: { Icon: Info, className: "bg-gray-100 text-gray-600 ring-gray-200" },
};
